import { ActionReducer, createFeatureSelector, createReducer, createSelector, MemoizedSelector, on } from '@ngrx/store';
import { StoreConfigurationActions } from '../actions';

export const storeConfigurationStoreName: string = 'storeConfiguration';

export interface StoreConfigurationState {
  error: any;
  isRfqOnly: boolean;
  minimumOrderValue: number;
}

export const initialState: StoreConfigurationState = {
  error: null,
  isRfqOnly: false,
  minimumOrderValue: 0,
};

const getStoreConfigurationFeatureState: MemoizedSelector<object, StoreConfigurationState> = createFeatureSelector<StoreConfigurationState>(storeConfigurationStoreName);

export const getIsRfqOnly: MemoizedSelector<object, boolean> = createSelector(
  getStoreConfigurationFeatureState,
  state => state.isRfqOnly
);

export const getMinimumOrderValue: MemoizedSelector<object, number> = createSelector(
  getStoreConfigurationFeatureState,
  state => state.minimumOrderValue
);

export const StoreConfigurationReducer: ActionReducer<StoreConfigurationState> = createReducer(
  initialState,

  on(StoreConfigurationActions.retrieveStoreConfigurationSuccess, (state, action): StoreConfigurationState => {
    return {
      ...state,
      isRfqOnly: action.storeConfiguration.data.attributes.isRfqOnly,
      minimumOrderValue: action.storeConfiguration.data.attributes.minimumOrderValue,
    };
  }),

  on(StoreConfigurationActions.retrieveStoreConfigurationFail, (state, action): StoreConfigurationState => {
    return {
      ...state,
      error: action.error
    };
  })
);
